import { ElementStore } from 'component/Carousel/store/ElementStore'
import { shiftLinear } from 'component/Carousel/util/position'

export function attachDrag(element: ElementStore): () => void {
  const { main } = element

  const state = {
    drag: false,
    move: false,
    start: 0,
    x: 0,
  }

  function startDrag(clientX: number) {
    state.drag = true
    state.move = false
    element.onStartDrag()
    state.start = element.position
    state.x = clientX
    main.classList.add('drag')
  }

  function moveDrag(clientX: number) {
    state.move = true
    requestAnimationFrame(() => {
      shiftLinear(element, state.start, state.x - clientX)
    })
  }

  function endDrag() {
    state.drag = false
    main.classList.remove('drag')
    element.onEndDrag()
  }

  function onClick(event: MouseEvent) {
    if (state.move) {
      event.stopPropagation()
    }
  }

  function onPointerDown(event: PointerEvent) {
    if (event.button > 0) return
    // клик по кнопке (лайк, шеринг и т.п.) не должен запускать драг карусели —
    // иначе active/stable мигает на время анимации, пока палец ещё на кнопке
    if ((event.target as HTMLElement | null)?.closest('button, a, [role="button"]')) return
    // только для мыши: на тач preventDefault подавил бы последующий click
    if (event.pointerType === 'mouse') event.preventDefault()
    startDrag(event.clientX)
  }

  function onPointerMove(event: PointerEvent) {
    if (!state.drag) return
    main.setPointerCapture(event.pointerId)
    moveDrag(event.clientX)
  }

  function onPointerUp(event: PointerEvent) {
    if (!state.drag) return
    try {
      main.releasePointerCapture(event.pointerId)
    } catch {
      // уже снят или отменён
    }
    endDrag()
    setTimeout(() => {
      state.move = false
    }, 10)
  }

  main.addEventListener('click', onClick)
  main.addEventListener('pointerdown', onPointerDown)
  main.addEventListener('pointermove', onPointerMove)
  main.addEventListener('pointerup', onPointerUp)
  main.addEventListener('pointercancel', onPointerUp)

  return () => {
    main.removeEventListener('click', onClick)
    main.removeEventListener('pointerdown', onPointerDown)
    main.removeEventListener('pointermove', onPointerMove)
    main.removeEventListener('pointerup', onPointerUp)
    main.removeEventListener('pointercancel', onPointerUp)
  }
}
